// supabase-js persists auth sessions to localStorage by default, but
// localStorage does not exist in a (Shared) Worker, so back it with a small
// dedicated IndexedDB instead. This DB is global (not per-league), like the
// meta DB.

const DB_NAME = "bbgm-multiplayer";
const STORE = "kv";

let dbPromise: Promise<IDBDatabase> | undefined;

const getDB = () => {
	if (!dbPromise) {
		dbPromise = new Promise((resolve, reject) => {
			const request = indexedDB.open(DB_NAME, 1);
			request.onupgradeneeded = () => {
				request.result.createObjectStore(STORE);
			};
			request.onsuccess = () => {
				resolve(request.result);
			};
			request.onerror = () => {
				reject(request.error);
			};
		});
	}
	return dbPromise;
};

const kvRequest = <T>(
	mode: IDBTransactionMode,
	makeRequest: (store: IDBObjectStore) => IDBRequest<T>,
): Promise<T> => {
	return getDB().then(
		(db) =>
			new Promise((resolve, reject) => {
				const request = makeRequest(
					db.transaction(STORE, mode).objectStore(STORE),
				);
				request.onsuccess = () => {
					resolve(request.result);
				};
				request.onerror = () => {
					reject(request.error);
				};
			}),
	);
};

export const kvGet = async (key: string): Promise<string | null> => {
	const value = await kvRequest("readonly", (store) => store.get(key));
	return value === undefined ? null : (value as string);
};

export const kvSet = async (key: string, value: string) => {
	await kvRequest("readwrite", (store) => store.put(value, key));
};

export const kvRemove = async (key: string) => {
	await kvRequest("readwrite", (store) => store.delete(key));
};

// The interface supabase-js expects for its auth storage option
export const authStorage = {
	getItem: kvGet,
	setItem: kvSet,
	removeItem: kvRemove,
};
